const docDownloadImg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
      <g fill="none" fill-rule="evenodd" stroke="#C9CCCD" stroke-linejoin="round" transform="translate(1 1)">
        <g transform="translate(9.167 10)">
          <polyline stroke-linecap="round" points="3.333 5.417 5.417 7.5 7.5 5.417"/>
          <circle cx="5.417" cy="5" r="5"/>
          <path stroke-linecap="round" d="M5.41666667,2.5 L5.41666667,7.5"/>
        </g>
        <g stroke-linecap="round">
          <polyline points="9.884 9.242 9.167 7.5 6.667 12.083 5 10.417 2.917 14.583 7.466 14.583"/>
          <circle cx="4.167" cy="5.833" r="1.25"/>
          <polyline points="8.75 17.917 .417 17.917 .417 .417 9.583 .417 13.75 4.583 13.75 7.917"/>
          <polyline points="9.583 .417 9.583 4.583 13.75 4.583"/>
        </g>
      </g>
    </svg>

`;

export default docDownloadImg;
